import css from 'styled-jsx/css';

const styles = css.global`button{background:none;border:none;padding:0;text-align:start}`;

export default styles;